(() => {
  const readVariants = () => {
    const node = document.querySelector('[data-cv-e8e-controller] [data-cv-e8e-variants]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (_) {
      return [];
    }
  };

  const initFaq = (root = document) => {
    root.querySelectorAll('[data-cv-e8e-faq]:not([data-cv-e8e-ready])').forEach((list) => {
      list.dataset.cvE8eReady = 'true';

      const syncExpandedState = (details) => {
        const summary = details.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      };

      list.querySelectorAll('details').forEach(syncExpandedState);

      list.addEventListener('keydown', (event) => {
        const summary = event.target.closest('summary');
        if (!summary || !list.contains(summary) || !['Enter', ' ', 'Spacebar'].includes(event.key)) return;

        const details = summary.parentElement;
        if (!(details instanceof HTMLDetailsElement)) return;

        event.preventDefault();
        details.open = !details.open;
        syncExpandedState(details);
      });

      list.addEventListener('toggle', (event) => {
        const opened = event.target;
        if (!(opened instanceof HTMLDetailsElement)) return;

        syncExpandedState(opened);
        if (!opened.open || list.dataset.multiple === 'true') return;

        list.querySelectorAll('details[open]').forEach((item) => {
          if (item !== opened) item.open = false;
        });
      }, true);
    });
  };

  const initFinalCta = (root = document) => {
    root.querySelectorAll('[data-cv-e8e-final-cta]:not([data-cv-e8e-ready])').forEach((cta) => {
      cta.dataset.cvE8eReady = 'true';
      const finalButton = cta.querySelector('[data-cv-e8e-final-add]');
      const finalPrice = cta.querySelector('[data-cv-e8e-final-price]');
      const status = cta.querySelector('[data-cv-e8e-final-status]');
      const purchase = document.querySelector('[data-cv-e8e-controller]');
      const variantInput = purchase?.querySelector('[data-cv-e8e-variant-input]');
      const variants = readVariants();

      if (!finalButton || !purchase || !variantInput) return;

      const currentVariant = () => variants.find((variant) => String(variant.id) === String(variantInput.value)) || variants[0];
      const syncVariant = () => {
        const variant = currentVariant();
        if (finalPrice && variant?.priceFormatted) finalPrice.textContent = variant.priceFormatted;
        const unavailable = !variant?.available;
        finalButton.disabled = unavailable;
        finalButton.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      };
      const syncPurchaseState = () => {
        const mainButton = purchase.querySelector('[data-cv-e8e-add]');
        if (!mainButton) return;
        const busy = mainButton.getAttribute('aria-busy') === 'true' || mainButton.hasAttribute('data-added');
        const unavailable = !currentVariant()?.available;
        finalButton.disabled = busy || unavailable;
        finalButton.setAttribute('aria-disabled', busy || unavailable ? 'true' : 'false');
        finalButton.setAttribute('aria-busy', busy ? 'true' : 'false');
        if (busy && status) status.textContent = 'Adding through the secure product form…';
      };

      variantInput.addEventListener('change', () => {
        syncVariant();
        syncPurchaseState();
      });

      finalButton.addEventListener('click', () => {
        const mainButton = purchase.querySelector('[data-cv-e8e-add]');
        if (!mainButton || mainButton.disabled) {
          if (status) status.textContent = 'Review the selected configuration in the purchase area above.';
          return;
        }
        if (status) status.textContent = 'Adding through the secure product form…';
        mainButton.click();
      });

      const purchaseObserver = new MutationObserver(() => {
        syncPurchaseState();
        const error = purchase.querySelector('[ref="addToCartTextError"]')?.textContent?.trim();
        if (error && status) status.textContent = error;
      });
      purchaseObserver.observe(purchase, {
        attributes: true,
        attributeFilter: ['aria-busy', 'data-added', 'disabled'],
        childList: true,
        characterData: true,
        subtree: true,
      });

      syncVariant();
      syncPurchaseState();
    });
  };

  const init = (root = document) => {
    initFaq(root);
    initFinalCta(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
